export const iconSize = 1;
export const gapBetweenIconAndText = 0.5;
